import React from 'react'
import moment from 'moment'
import { Form, FormStepper, ButtonGroup, Button, PropertyBar, ErrorText } from './../components'
import DocumentsScene from './scenes/DocumentsScene'
import * as routeService from '../services/routeService'
import * as translationService from '../services/translationService'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { PHASE_INFORMATION_SUCCESS } from '../actions/FlowAction'
import { sendApplicationToBroker, getErrorCode } from '../services/applicationSubmitService'
import { getCurrentStepType } from '../services/stepService'
import { scroller } from 'react-scroll'

class DocumentsView extends React.PureComponent {
  static propTypes = {
    user: PropTypes.any,
    step: PropTypes.any,
    property: PropTypes.any,
    updatePhaseInformation: PropTypes.any,
    isUploading: PropTypes.bool,
  }

  state = {
    dateToggle: '',
    startDate: moment(),
    mainError: null,
    currentItem: null,
    isSubmitting: false,
    touched: false,
  }

  documentsRef = {}

  componentDidMount = () => {
    scroller.scrollTo('mainContent', {
      smooth: true,
    })
  }

  onRadioButtonChange = ({ target: { value, name } }) => {
    this.setState({
      [name]: value,
    })
  }

  onDateChange = (date, name) => {
    this.setState({ [name]: date })
  }

  goToPreviousFlow = () => {
    this.documentsRef
      .onSubmit(false)
      .then(() => {
        routeService.goToNextFlowPage(this.props.step, -1)
      })
      .catch(() => {})
  }

  goToNextFlow = async () => {
    const { step } = this.props
    const isGeneralStep = getCurrentStepType(step) === 'GENERAL_STEPS'
    this.setState({ isSubmitting: true })

    if (isGeneralStep) {
      this.documentsRef
        .onSubmit()
        .then(() => {
          routeService.goToNextFlowPage(this.props.step)
        })
        .catch(() => {
          this.setState({ touched: true, isSubmitting: false })
        })
    } else {
      try {
        await this.documentsRef.onSubmit()
        const now = new Date()
        await sendApplicationToBroker(this.props.user.id, this.props.property.id, this.props.step)
        routeService.goToThankyouPage()
        this.props.updatePhaseInformation(now.toISOString(), this.props.step)
      } catch (err) {
        this.setState({ touched: true, isSubmitting: false })
        // The outer guard stays: this view deliberately shows nothing when there is no
        // response at all. Reading the code rather than destructuring keeps it from throwing
        // on a response that has no data or no error object.
        if (err.response) {
          if (getErrorCode(err) === 'EMAIL_NOT_VERIFIED') {
            this.setState({
              touched: true,
              mainError: translationService.t('system.error.EMAIL_NOT_VERIFIED'),
              isSubmitting: false,
            })
          } else {
            this.setState({
              touched: true,
              mainError: translationService.t('system.500.server.error'),
              isSubmitting: false,
            })
          }
        }
      }
    }
  }

  render() {
    const { mainError } = this.state
    const { property, step } = this.props
    const isGeneralStep = getCurrentStepType(step) === 'GENERAL_STEPS'

    return (
      <div>
        {property && <PropertyBar property={property} />}
        <FormStepper steps={routeService.getStepperRoutes(this.props.step, property.zip)} />
        <Form>
          {mainError && (
            <div>
              <ErrorText>{mainError}</ErrorText>
              <br />
            </div>
          )}
          <DocumentsScene onRef={ref => (this.documentsRef = ref)} />
          <div>
            <ButtonGroup>
              <Button onClick={this.goToPreviousFlow}>{translationService.buttonPrevious()}</Button>
              <Button onClick={this.goToNextFlow} primary loading={this.props.isUploading || this.state.isSubmitting}>
                {isGeneralStep ? translationService.buttonNext() : translationService.overviewSendAction(step)}
              </Button>
            </ButtonGroup>
          </div>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = ({ AppReducer, FlowReducer, AuthReducer }) => {
  const { user = {} } = AuthReducer
  const { step, property } = FlowReducer
  const { isUploading } = AppReducer
  return {
    user,
    step,
    property,
    isUploading,
  }
}

const mapDispatchToProps = dispatch => ({
  updatePhaseInformation: (completedAt, step) => {
    dispatch({
      type: PHASE_INFORMATION_SUCCESS,
      completedAt,
      step,
    })
  },
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(DocumentsView)



// WEBPACK FOOTER //
// ./src/views/DocumentsView.js